<template>
    <header class="header">
        <div class="header__wrapper">
            <div class="wrapper">
                <div class="header__row">
                    <div class="header__col">
                        <n-link
                            class="header__link"
                            to="/"
                        >
                            <nuxt-img
                                class="header__logo-img"
                                src="logo.svg"
                                alt="Банк Центр-инвест"
                                title="Логотип банка Центр-инвест"
                            />
                        </n-link>
                        <transition
                            name="fade"
                            mode="out-in"
                        >
                            <HeaderMobileMenu
                                :is-open="isMenuVisible"
                                class="header__mobile-menu"
                            />
                        </transition>
                        <TheHeaderMenu
                            class="header__desktop-menu"
                        />
                    </div>
                    <div class="header__col">
                        <HeaderAdditionalActions />
                    </div>
                </div>
                <HeaderBurgerMenu
                    :is-open="isMenuVisible"
                    @click="isMenuVisible = !isMenuVisible"
                />
            </div>
        </div>
        <div class="header__main-menu-wrapper">
            <div class="wrapper flex justify-between">
                <div class="header__row justify-between">
                    <div class="header__col">
                        <TheMainMenu />
                    </div>
                    <div class="header__col">
                        <HeaderSearch />
                    </div>
                </div>
            </div>
        </div>
        <BreadCrumbs />
    </header>
</template>

<script>
import {defineComponent, computed, ref, watch} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';
import {useNavigationStore} from '@/stores/navigation';

import HeaderSearch from '@/components/Sections/Header/HeaderSearch.vue';
import HeaderAdditionalActions from '@/components/Sections/Header/HeaderAdditionalActions.vue';
import BreadCrumbs from '@/components/Navigation/TheBreadcrumbs.vue';
import TheMainMenu from '@/components/Navigation/TheMainMenu.vue';
import HeaderBurgerMenu from '@/components/Sections/Header/HeaderBurgerMenu.vue';
import TheHeaderMenu from '@/components/Navigation/TheHeaderMenu.vue';
import HeaderMobileMenu from '@/components/Sections/Header/HeaderMobileMenu.vue';

export default defineComponent({
    name: 'TheHeader',
    components: {
        HeaderSearch,
        HeaderAdditionalActions,
        BreadCrumbs,
        TheMainMenu,
        HeaderBurgerMenu,
        TheHeaderMenu,
        HeaderMobileMenu,
    },
    setup() {
        const route = useRoute();
        const navigationStore = useNavigationStore();
        const menu = computed(() => navigationStore.menu);

        const isMenuVisible = ref(false);

        watch(() => route.value.path, (newVal, oldval) => {
            if (!newVal || newVal === oldval) {
                return;
            }

            isMenuVisible.value = false;
        });

        return {
            menu,
            isMenuVisible,
        };
    },
});
</script>

<style scoped lang="scss">
@import '@/assets/styles/common/header/header';
</style>
